<div class="spinner-border" role="status">
  <span class="sr-only">Загрузка...</span>
</div>
